export default __webpack_public_path__ + "72b30795d9d9fd4aa120ace3e8022112.jpg";